if (!process.env.VUE_APP_IS_WEB) {
  // ???: .. todo?
  // var ConfigurationDB = require("../database/models/Configuration");
}

import ConfigurationORM from "@/store/orm-axios/models/Configuration";

export default {
  FETCH(agencyId) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new ConfigurationDB()
          .query({ where: { agency_id: agencyId, deleted: null } })
          .fetchAll()
          .then(res => {
            ConfigurationORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ConfigurationORM.api()
          .FETCH(agencyId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET(id) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new ConfigurationDB({ id: id, deleted: null })
          .fetch()
          .then(res => {
            ConfigurationORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ConfigurationORM.api()
          .GET(id)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  POST(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new ConfigurationDB(item)
          .save()
          .then(res => {
            var configuration = res.serialize();
            ConfigurationORM.insertOrUpdate({
              data: configuration,
            });
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ConfigurationORM.api()
          .POST(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  PUT(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new ConfigurationDB(item)
          .save(null, { isUpdate: true })
          .then(res => {
            ConfigurationORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ConfigurationORM.api()
          .PUT(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  DELETE(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new ConfigurationDB(item)
          .save(null, { isDelete: true })
          .then(res => {
            ConfigurationORM.delete(item.id);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ConfigurationORM.api()
          .DELETE(item)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
